import React, { Component, type ErrorInfo, type ReactNode } from 'react';
import { AlertTriangle, RotateCcw } from 'lucide-react';

type Props = { children: ReactNode };
type State = { failed: boolean };

export default class AssistantErrorBoundary extends Component<Props, State> {
  state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Assistant UI failed without interrupting core restaurant operations.', {
      error: error.message,
      componentStack: info.componentStack,
    });
  }

  render() {
    if (!this.state.failed) return this.props.children;
    const isArabic = typeof document !== 'undefined' && document.documentElement.dir === 'rtl';
    return (
      <div dir={isArabic ? 'rtl' : 'ltr'} className="fixed bottom-5 end-5 z-[90] flex max-w-72 items-center gap-3 rounded-lg border border-amber-300 bg-white p-3 text-start shadow-xl">
        <AlertTriangle className="h-5 w-5 shrink-0 text-amber-700" />
        <div className="min-w-0 flex-1">
          <p className="text-xs font-black text-slate-950">{isArabic ? 'المساعد الذكي غير متاح' : 'AI assistant unavailable'}</p>
          <p className="mt-0.5 text-[10px] font-bold text-slate-500">{isArabic ? 'أدوات المطعم الأساسية غير متأثرة.' : 'Core restaurant tools are unaffected.'}</p>
        </div>
        <button
          type="button"
          title={isArabic ? 'إعادة تشغيل المساعد' : 'Retry assistant'}
          aria-label={isArabic ? 'إعادة تشغيل المساعد' : 'Retry assistant'}
          onClick={() => this.setState({ failed: false })}
          className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg text-slate-600 hover:bg-slate-100"
        >
          <RotateCcw className="h-4 w-4" />
        </button>
      </div>
    );
  }
}
